import { useUserDetails } from "@/composables/user-details";

export function useAuthenticatedUser() {
  return useUserDetails('me')
}